// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"6fa34748","885":"37d523be"}[chunkId] + ".chunk.js";
};